module.exports = __webpack_public_path__ + "img/succ.aacc287b.png";